(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "lodash"], factory);
	else if(typeof exports === 'object')
		exports["Plots"] = factory(require("react"), require("react-dom"), require("lodash"));
	else
		root["Plots"] = factory(root["React"], root["ReactDOM"], root["_"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__442__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__276__) => {
return 